<template>
    <div class="banner_image_abs">
        <div class="hero_image image_decor">
            <picture v-full-image-path:assets="image" />
        </div>

        <div class="banner_image_decor">
            <picture v-full-image-path:assets="'banner_image_decor.svg'" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: String,
            required: true
        }
    }
};
</script>
